import React from "react";
import CheckLoginUser, { AuthProvider } from "./AuthContext";
import { AuthInterceptor } from "../Components/Auth/AuthInterceptor";
import { AppRoutes } from "../Routes/Routes";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

const App = () => {
  AuthInterceptor();
  CheckLoginUser();

  return (
    <AuthProvider>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <AppRoutes />
      </LocalizationProvider>
    </AuthProvider>
  );
};

export default App;
